import styled from 'styled-components';
import { GDBREAKPOINTS_LIVE_MINI } from '@gameday/components/themes/breakpoints';
import Card from '../Card/Card';
import { MatchupWrapper } from '../Matchup//Matchup.style';
import { PlayerDuelWrapper } from '../PlayerDuel/PlayerDuel.style';
import { MainWrapper, UpcomingBattersContainer } from '../PlayerDuel/components/UpcomingBatters/UpcomingBatters.style';
import { GamedayLineScoreWrapper } from '../LineScore/LineScore.style';

const { SM_MAX, MD_MIN } = GDBREAKPOINTS_LIVE_MINI

export const LiveMiniWrapper = styled.div`
    margin: 0 auto;
`;

export const LiveMiniScoreWrapper = styled.div`
    border-bottom: 1px solid var(--gameday-divider-color);
    background-color: var(--gameday-background-color);
    border-radius: 8px 8px 0 0;
`;

export const LiveMiniMatchupWrapper = styled.div`

    ${MatchupWrapper} {
        padding:0;
    }

    ${PlayerDuelWrapper} {
        padding-right: var(--gameday-section-padding-sm);
        padding-left: var(--gameday-section-padding-sm);
        margin-top:0;
    }

    ${MainWrapper} {
        margin-top:0;
        padding-right: var(--gameday-section-padding-sm);
        padding-left: var(--gameday-section-padding-sm);
    }

    ${UpcomingBattersContainer} {
        padding-bottom: 8px;
        margin-bottom: 0;
    }
`;


export const MainGameInfoWrapper = styled.div`
    width: 100%;
    display: flex;
    margin-top: var(--gameday-section-padding-sm);

    @media (max-width: ${SM_MAX}) {
        display: block;
        margin-right: 16px;
        margin-left: 16px;
        width: calc(100% - 32px);
    }


`;

export const GameInfoWrapper = styled.div`
    width: 50%;
    display: inline-block;
    padding-bottom: var(--gameday-section-padding-sm);

    @media (max-width: ${SM_MAX}){
        width: 100%;
        display: block;           
    }
`;

export const InfoWrapper = styled(Card)`
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);
    font-family: var(--gameday-primary-font);
    margin: 0 0 0 var(--gameday-section-padding-sm);
    height: calc(100% - 68px);
    
    @media (min-width: ${MD_MIN}) {
        > div {
            position: relative;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    
    &.right {
        margin-right: var(--gameday-section-padding-sm);
    }

    @media (max-width: ${SM_MAX}){
      width: calc(100% - 32px);
      display: block;
      box-sizing: content-box !important;
      margin: var(--gameday-section-padding-sm) auto;
      padding-right: var(--gameday-section-padding-sm);
      padding-left: var(--gameday-section-padding-sm);
      height: auto;
    }

    ${GamedayLineScoreWrapper} {
        height: 76px;
    }
`;

export const Title = styled.div`
  font-size: var(--gameday-card-title-font-size);
  line-height: var(--gameday-card-title-line-height);
  font-weight: var(--gameday-card-title-font-weight);
  color: var(--gameday-card-title-color);
  margin-bottom: 16px;
  font-family: var(--gameday-primary-font);
  margin-left: 16px;
  @media (max-width: ${SM_MAX}){
    margin-left: 0;
  }
`;